import axios from "@/api/config_php";

/**
 * AI视频消耗折线图+汇总
 * @param {object} param 
 * @property {'day' | 'week' | 'month'} type 统计类型
 * @property {string} start_date 开始日期
 * @property {string} end_date 结束日期
 * @returns {Promise<{code:number,data:any,msg:string}>}
 */
export const getVideoCostStatistics = params => axios.get("/amp/api/v1/aiVideoStatistics/getVideoCostStatistics", {params});

/**
 * AI视频消耗折线图+汇总
 * @param {object} param 
 * @property {string} start_date 开始日期
 * @property {string} end_date 结束日期
 * @returns {Promise<{code:number,data:any,msg:string}>}
 */
export const getVideoDayCostStatistics = params => axios.get("/amp/api/v1/aiVideoStatistics/getSingleDayStatistics", {params});
